<template>
  <div class="role-page full-height">
    <table-con canReturn="1">
      <div slot="editBreadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/message' }">{{ $t("common.home") }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t("recycle.recycle1") }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row" style="padding: 0px">
          <el-col :span="6" class="display-row">
            <div class="query-title">{{ $t("recycle.recycle8") }}:</div>
            <div class="flex1">
              <el-date-picker
                clearable
                v-model="queryInfo.updateTime"
                type="date"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :placeholder="$t('common.selectDate')"
              ></el-date-picker>
            </div>
          </el-col>
          <el-col :span="18" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px; float: right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{ $t("common.reset") }}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{ $t("common.search") }}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle"
          :data="recycleList"
          border
          stripe
          height="550"
          :row-style="{ height: '40px' }"
        >
          <!-- <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column> -->
          <el-table-column prop="updateTime" sortable align="center" :index="indexMethod" :label="$t('recycle.recycle8')">
            <template v-slot="scope">
              {{ scope.row.updateTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" sortable align="center" :index="indexMethod" :label="$t('recycle.recycle7')">
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column prop="communicateCount" sortable align="center" :index="indexMethod" :label="$t('recycle.recycle6')"> </el-table-column>
          <el-table-column sortable align="center" :index="indexMethod" :label="$t('handle')">
            <template v-slot="scope">
              <span class="primary-text" @click="handleInfo(scope.row)">{{ $t("orderList.orderList146") }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <!-- 详情 -->
    <el-dialog :title="$t('detail')" :visible.sync="detailFlag" width="800px">
      <div v-if="messageDetailList.length" class="message-content-right">
        <!-- 过往收发详情列表 -->
        <div v-for="(item, index) in messageDetailList" class="message-list-item" :class="{ 'history-message-item': index !== 0 }">
          <h3 :class="{ 'first-title': index === 0 }">{{ item.remindingTitle }}</h3>
          <div class="send-info">
            <span>
              {{ `${$t("mess.mess47")}：` }}
              <span :style="{ color: '#fff', backgroundColor: prefixColor(item, 'createUserName'), padding: '0 5px' }">{{
                prefix(item, "createUserName")
              }}</span>
              <span :style="{ color: prefixColor(item, 'createUserName') }">{{
                prefix(item, "createUserName") === $t("recycle.recycle11") ? $t("mess.mess77") : item.createUserName
              }}</span>
            </span>
            <span>
              {{ `${$t("mess.mess67")}：` }}
              <span :style="{ color: '#fff', backgroundColor: prefixColor(item, 'remindingUserName'), padding: '0 5px' }">{{
                prefix(item, "remindingUserName")
              }}</span>
              <span :style="{ color: prefixColor(item, 'remindingUserName') }">{{
                prefix(item, "remindingUserName") === $t("recycle.recycle11") ? $t("mess.mess77") : item.remindingUserName
              }}</span>
            </span>
            <span>{{ `${$t("mess.mess20")}：${dataTimeFn(item.createTime)}` }}</span>
          </div>
          <div class="rich-text-content">
            <div v-html="item.remindingContent"></div>
          </div>
          <el-form label-width="130px" label-position="left" class="history-detail-form">
            <el-form-item label-width="0px">
              <el-col :span="8">
                <el-form-item :label="`${$t('mess.mess19')}：`">
                  <span class="under-text primary-text" @click="toOrderDetail(item)">
                    {{ item.orderId || $t("mess.mess68") }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <el-form-item :label="`${$t('mess.mess69')}：`">
                  <span class="under-text primary-text" @click="toFBA">{{ item.containerBatchNo || $t("mess.mess68") }}</span>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item :label="`${$t('mess.mess45')}：`">
              <div v-if="item.fileModels && item.fileModels.length" class="annex-list">
                <div class="annex-list-item" v-for="annex in item.fileModels">
                  <span class="under-text primary-text file-name text-overflow" @click="downloadFile(annex.fileName, annex.filePath)">{{
                    annex.fileName
                  }}</span>
                  <span class="under-text primary-text" @click="downloadFile(annex.fileName, annex.filePath)">{{
                    $t("orderList.orderList147")
                  }}</span>
                </div>
              </div>
              <span v-else class="under-text primary-text">{{ $t("mess.mess68") }}</span>
            </el-form-item>
          </el-form>
          <div class="history-text" v-if="messageDetailList.length > 1 && index === 0">{{ $t("mess.mess70") }}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-blue" @click="detailFlag = false">{{ $t("confirm") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dataTimeFn, prefix, prefixColor } from "@/assets/js/utils";
import tableCon from "../../views/tableContainer";

export default {
  components: { tableCon },
  data() {
    return {
      queryInfo: {
        tradingNo: "",
        createTimeStart: "",
        createTimeEnd: "",
        pageSize: 10,
        pageNum: 1,
      },
      orderDateRangeValue: [],
      recycleList: [],
      total: 0,
      detailFlag: false,
      messageDetailList: [],
      dataTimeFn,
      activeItem: null,
      prefix,
      prefixColor
    };
  },
  methods: {
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getRecycleList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getRecycleList();
    },
    searchList() {
      //查询
      this.queryInfo.pageNum = 1;
      this.getRecycleList();
    },
    async getRecycleList() {
      const { data: res } = await this.$http.get("cmUser/message2/getRecycleList", { params: this.queryInfo });
      console.log(res);
      this.recycleList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear() {
      //清空
      this.queryInfo = {
        createTimeStart: "",
        createTimeEnd: "",
        tradingNo: "",
        pageSize: 10,
        pageNum: 1,
      };
      this.orderDateRangeValue = [];
    },
    handleInfo(item) {
      this.activeItem = item;
      this.getRightDetail(item);
    },
    getRightDetail(item) {
      if (item.messageGroupId) {
        this.$http
          .get("/cmUser/message2/groupList", {
            params: {
              messageGroupId: item.messageGroupId,
              remindingUserName: item.remindingUserName,
            },
          })
          .then(({ data: res }) => {
            if (res.code === 200) {
              this.detailFlag = true;
              this.messageDetailList = res.data || [];
            }
          })
          .catch(() => {
            this.$message.error(this.$t("prompt.failed"));
          });
      } else {
        this.$http.get(`cmUser/message/queryMessageInfo/${item.id}`).then(({ data: res }) => {
          if (res.code === 200 && res.data) {
            this.detailFlag = true;
            this.messageDetailList = res.data || [];
          }
        });
      }
    },
    toFBA() {
      this.$router.push("/fba");
    },
    toOrderDetail(row) {
      if (row.orderId) {
        this.$http
          .get("/cmUser/message2/orderIsExist", { params: { orderId: row.orderId } })
          .then(({ data: res }) => {
            if (res.code === 200) {
              if (!res.data) {
                this.$message.warning(this.$t("mess.mess80"));
              } else {
                if (row.orderId.indexOf("R") != -1 || row.orderId.indexOf("C") != -1) {
                  //R出现或者C出现
                  this.$router.push({
                    //充值记录
                    name: "rechargeList",
                    query: {
                      rechargeNo: row.orderId,
                    },
                  });
                } else {
                  //订单详情
                  this.$router.push({
                    name: "orderDetail",
                    query: {
                      id: row.orderId,
                      isEdit: "0",
                    },
                  });
                }
              }
            }
          })
          .catch(() => {
            this.$message.warning(this.$t("mess.mess81"));
          });
      } else {
        // 订单列表
        this.$router.push("orderList");
      }
    },
    downloadFile(name, url) {
      let formdata = new FormData();
      formdata.append("FileUrl", url);
      formdata.append("FileName", name);
      this.$http({
        url: "aliyun/oss/download",
        method: "post",
        data: formdata,
        responseType: "blob", //关键点
      }).then((res) => {
        //下载文件操作
        const link = document.createElement("a");
        let blob = new Blob([res.data], { type: "" }); //生成blob对象
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", name); //下载的文件名以及文件格式
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    orderDateRangeValue() {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.orderDateRangeValue) {
        this.orderDateRangeValue = [];
        this.queryInfo.createTimeStart = "";
        this.queryInfo.createTimeEnd = "";
      } else {
        if (this.orderDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
          this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
        }
      }
    },
  },
  created() {
    this.getRecycleList();
  },
};
</script>

<style lang="less" scoped>
.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rich-text-content {
  margin: 15px 0;
  padding: 50px 15px;
  background: #f2f2f2;
  ::v-deep img {
    max-width: 100%;
  }
}
.send-message-wrap {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s;
}
.message-list-item {
  border-bottom: 3px solid #ccc;
  padding-bottom: 20px;
  position: relative;
  .history-detail-form {
    ::v-deep .el-form-item {
      margin-bottom: 0;
    }
  }
  .history-text {
    position: absolute;
    left: 50%;
    bottom: -20px;
    background: #fff;
    transform: translateX(-50%);
    padding: 10px;
  }
  h3 {
    font-size: 14px;
    margin: 10px 0;
  }
  .send-info {
    display: flex;
    background-color: #fff;
    line-height: 50px;
    gap: 35px;
  }
  .association {
    display: flex;
    gap: 35px;
  }
  .annex-list {
    width: 54%;
    .annex-list-item {
      display: flex;
      justify-content: space-between;
      height: 28px;
      .file-name {
        max-width: 70%;
      }
    }
  }
}
.send-list-operate {
  position: absolute;
  top: -26px;
  right: -10px;
}
.message-content-right {
  position: relative;
}
.under-text {
  text-decoration: underline;
  cursor: pointer;
}
.primary-text {
  cursor: pointer;
  color: #3e8ef7;
}
.reply {
  max-height: 800px;
  transition: max-height 0.5s;
}
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
.query-title {
  width: 100px;
}
.search-btn {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
